export const FETCH_DATA = 'INTERNET:FETCH_DATA';
export const FETCH_DATA_SUCCESS = 'INTERNET:FETCH_DATA_SUCCESS';
export const FETCH_DATA_ERROR = 'INTERNET:FETCH_DATA_ERROR';
export const FETCH_SOCIAL_INTERNET_DATA = 'INTERNET:FETCH_SOCIAL_INTERNET_DATA';
export const SET_SERVICE_ADDITIONAL_CONNECTION_DATA = 'INTERNET:SET_SERVICE_ADDITIONAL_CONNECTION_DATA';
export const SWITCH_SOCIAL_INTERNET_POPUP_VISIBLE = 'INTERNET:SWITCH_SOCIAL_INTERNET_POPUP_VISIBLE';
export const SET_SOCIAL_INTERNET_VALUES = 'INTERNET:SET_SOCIAL_INTERNET_VALUES';
export const SWITCH_FIREWALL_FORM_VISIBLE = 'INTERNET:SWITCH_FIREWALL_FORM_VISIBLE';
export const SET_FIREWALL_VALUES = 'INTERNET:SET_FIREWALL_VALUES';
export const SET_SERVICE_ADDITIONAL_POPUP_DATA = 'INTERNET:SET_SERVICE_ADDITIONAL_POPUP_DATA';
export const SET_SERVICE_WITH_VALUES = 'INTERNET:SET_SERVICE_WITH_VALUES';
export const SET_ADDITIONAL_SERVICE_POPUP_VISIBLE = 'INTERNET:SET_ADDITIONAL_SERVICE_POPUP_VISIBLE';
export const SET_ADDITIONAL_SERVICE_EMAIL = 'INTERNET:SET_ADDITIONAL_SERVICE_EMAIL';
export const CHECK_SERVICE_ADDITIONAL_USER_AGREEMENT = 'INTERNET:CHECK_SERVICE_ADDITIONAL_USER_AGREEMENT';
export const CHANGE_ADDITIONAL_SERVICE_POPUP_TYPE = 'INTERNET:CHANGE_ADDITIONAL_SERVICE_POPUP_TYPE';

export const SERVICE_TYPE = {
  drweb: 1,
  esetNod: 2,
  kaspersky: 3,
  staticIP: 5,
  firewall: 10,
  socialInternet: 1000,
};

export const SERVICE_CONNECTION_CODES = {
  /** Запрос на подключение отправлен
   * @code 0
   * */
  SUCCESED: 0,
  /** Доверительный платеж
   * @code -1
   * */
  PROMISED: 1,
  /** Ошибка: что-то пошло не так
   * @code 2
   * */
  ERROR: 2,
  /** Недостаточно денег на счете
   * @code 3
   * */
  NO_MONEY: 3,

  /** Фейковый код для состояния запроса получения данных для подключения услуги.
   * @code -1
   * @notice Не приходит от backend, используется только на клиенте
   * */
  CONNECTING: -1,
  /** Фейковый код для промежуточного состояния, когда ожидается ответ от бэкенда.
   * @code 99
   * @warning Бекенд не присылает этот код, используется только на клиенте
   * */
  LOADING: 99,
};

const PREV_REQUEST_IN_PROGRESS_MESSAGE = `Мы еще обрабатываем ваш предыдущий запрос.
                                                 Пожалуйста, дождитесь его исполнения и повторите попытку`;

const SOMETHING_WENT_WRONG = 'При выполнении операции произошла ошибка. Попробуйте еще раз';

export const ERROR_MESSAGES = {
  PREV_REQUEST_IN_PROGRESS_MESSAGE: { message: PREV_REQUEST_IN_PROGRESS_MESSAGE },
  SOMETHING_WENT_WRONG: { message: SOMETHING_WENT_WRONG },
};

export const OWNERSHIP_TYPE = {
  RENT: 'R',
  BUYED: 'B',
  GIFT: 'G',
  BUY: 'Куплен',
  PRESENT: 'Подарок',
};

export const RETURN_OPTION_TYPE = {
  courier: 'courier',
  office: 'office',
};
